import { BotConfiguration } from '@feedyou/schema'
import produce from 'immer'
import { BotLevelPermissions } from '@feedyou/schema/dist/typescript/botLevelPermissions'
import { countElements } from '@feedyou/utils'

import { PAID_ROLES } from '../../../../constants/roles'
import { generateId } from '../../../../lib/generateId'

export const injectAccessTokensWhenMissing = (config: Partial<BotConfiguration['permissions']>) => {
  return produce(config, draft => {
    draft?.tokens?.forEach(item => {
      if (!item.token) {
        item.token = generateId.accessToken()
      }
    })
  })
}

export function wasNewPaidUserAdded(
  initialPermissions: BotLevelPermissions | undefined,
  formDataPermissions: BotLevelPermissions | undefined
): boolean {
  const initialPaidUserCount = countElements(
    initialPermissions?.users, // I <3 PRETTIER
    user => PAID_ROLES.includes(user.role)
  )

  const newPaidUserCount = countElements(
    formDataPermissions?.users, // I <3 PRETTIER
    user => PAID_ROLES.includes(user.role)
  )

  return newPaidUserCount > initialPaidUserCount
}
